import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { AlertService } from '../shared/services/alert.service';
import { PostJsonObjectService } from '../shared/services/post-json-object.service';
import { first } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material-module';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [MaterialModule, FormsModule, ReactiveFormsModule, CommonModule, RouterModule],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public resetPasswordForm!: FormGroup;
  public loading: boolean = false;
  deviceService: any;
  public hide1: boolean = true;
  public hide2: boolean = true;
  public hide3: boolean = true;
  private code: string | null = null;
  public email: string | null = null;
  public postWainting : boolean = false
  public isSetMsgType : boolean = true


  constructor(/*private sharedDataService: SharedDataService,*/
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private postJsonObjectService: PostJsonObjectService, ) { }


  ngOnInit() {
    if(this.router.url.includes("reset-password"))
      this.isSetMsgType = false;
      
    this.code = this.route.snapshot.queryParamMap.get("code")
    if(this.code != null)
    {
      this.route.queryParamMap.subscribe(queryParams => {
        this.code = queryParams.get("code")
        this.email = queryParams.get("email")
      })
    }


    this.resetPasswordForm = this.formBuilder.group({
      passwordNew: ['', Validators.compose([
                        Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}')                   
                        ])
                   ],
      newPasswordConfirm: ['', Validators.compose([
                               Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}')                   
                               ])
                          ],
    });
  }

  public onSubmit() {

    if (this.resetPasswordForm.invalid) {
      return;
    }
    this.loading = true;
    if (this.resetPasswordForm.controls['newPasswordConfirm'].value != this.resetPasswordForm.controls['passwordNew'].value) {
      this.alertService.error({ "subType": "", "message": "les mots de passes diffèrent" })
      this.loading = false;
      return;
    }
    
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    let objectTosend =
    {
      email: this.email,
      password: this.resetPasswordForm.controls['passwordNew'].value,
      confirmPassword: this.resetPasswordForm.controls['newPasswordConfirm'].value,
      code: this.code
    }
    this.postWainting = true
    this.postJsonObjectService.sendJson("/auth/v1/account/reset-password", objectTosend, httpOptions).pipe(
      first()).subscribe(
        result => {
          this.postWainting = false
          if (result != null && (result.succeeded === false || result === "ko")) {
            this.loading = false;
            let strErrorMessage = ""
            for (let i = 0; i < result.errors.length; i++) {
              switch (result.errors[i].code) {
                case 'PasswordRequiresNonAlphanumeric':
                  strErrorMessage = 'Le mot de passe doit contenir des caractères non alphanumériques. ';
                  break;
                case 'PasswordRequiresDigit':
                  strErrorMessage = strErrorMessage + 'Le mot de passe doit contenir des chiffres. ';
                  break;
                case 'PasswordRequiresUpper':
                  strErrorMessage = strErrorMessage + 'Le mot de passe doit contenir des lettres majuscules. ';
                  break;
                case 'PasswordTooShort':
                  strErrorMessage = strErrorMessage + 'Le mot de passe est trop court. ';
                  break;
                case 'PasswordRequiresLower':
                  strErrorMessage = strErrorMessage + 'Le mot de passe doit contenir des lettres minuscules. ';
                  break;
                case 'DuplicateUserName':
                  strErrorMessage = strErrorMessage + '';
                  break;
                case 'DuplicateEmail':
                  strErrorMessage = strErrorMessage + 'L\'adresse E-mail existe déja.';
                  break;
                case 'InvalidToken':
                    strErrorMessage = strErrorMessage + 'Lien de re-initialisation invalide';
                    break;                  
                default:
                  strErrorMessage = strErrorMessage + result.errors[i].description;
                  break;

              }
              this.alertService.error({ "subType": "", "message": strErrorMessage })
            }
          }
          else {
            this.alertService.success("Votre mot de passe a été modifié");
            this.router.navigate(['/login']);
          }
        })
  }
}
